import * as React from "react";
import classnames from "classnames";
import { Tabs, Tab } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
/* empty css                        */
const LocationSearchTabs = ({
  className,
  labels,
  tabIndex,
  onChange,
  listContent,
  isMobile,
  mapContent,
  showTabs = false,
  tabsRef,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, ref: tabsRef, className: classnames("location-search-tabs", className) }, /* @__PURE__ */ React.createElement(Tabs, { activeTabIndex: tabIndex, onChange }, /* @__PURE__ */ React.createElement(
  Tab,
  {
    className: classnames("location-search-tabs__tab", {
      "location-search-tabs__tab--hidden": !showTabs
    }),
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { className: "location-search-tabs__tab-icon", name: "list" }), /* @__PURE__ */ React.createElement("span", { className: "location-search-tabs__tab-label" }, labels.listTab))
  }
), /* @__PURE__ */ React.createElement(
  Tab,
  {
    className: classnames("location-search-tabs__tab", {
      "location-search-tabs__tab--hidden": !showTabs
    }),
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { className: "location-search-tabs__tab-icon", name: "location" }), /* @__PURE__ */ React.createElement("span", { className: "location-search-tabs__tab-label" }, labels.mapTab))
  }
)), /* @__PURE__ */ React.createElement("div", { className: "location-search-tabs__content" }, /* @__PURE__ */ React.createElement(
  "div",
  {
    className: classnames(
      "location-search-tabs__content-item",
      "location-search-tabs__content-item-list",
      {
        "location-search-tabs__content-item--active": tabIndex === 0
      }
    )
  },
  isMobile && tabIndex !== 0 ? null : listContent
), /* @__PURE__ */ React.createElement(
  "div",
  {
    className: classnames(
      "location-search-tabs__content-item",
      "location-search-tabs__content-item-map",
      {
        "location-search-tabs__content-item--active": tabIndex === 1
      }
    )
  },
  isMobile && tabIndex !== 1 ? null : mapContent
)));
export {
  LocationSearchTabs as default
};
//# sourceMappingURL=LocationSearchTabs.js.map
